import { useSelector } from "react-redux";
import {
  TradeIconComponent,
  MessagesBubbleIcon,
  DashedClockIcon,
} from "assets/icons";
import LockedFeature from "components/Conversations/UserInfoBox/LockedFeature";
import useTranslation from "hooks/useTranslation";
import styles from "./styles.module.scss";

const getUnreadBadgeForConvTypes = ({ chatsData }) => ({
  pending: chatsData.unreadPendingMessage,
  ongoing: chatsData.unreadOngoingMessage,
});

const getConvsTotalCounts = ({ chatsData }) => ({
  pending: chatsData.pending.totalCount,
  ongoing: chatsData.ongoing.totalCount,
  otherConvs: chatsData.otherConvs.totalCount,
});

const getContainer = ({ userData }) => userData.container.data;

const getOtherConvsFeatAccess = ({ userData }) =>
  userData.container.data.otherConversationsEnabled;

function ConvSelectHead({ type, selectedType, onSelectConvType }) {
  const unreadBadges = useSelector(getUnreadBadgeForConvTypes);
  const totalCounts = useSelector(getConvsTotalCounts);
  const otherConversationsFeatAccess = useSelector(getOtherConvsFeatAccess);
  const container = useSelector(getContainer);

  // TODO: it is not a good way to check if container data is loaded. better to implement loading
  const containerLoaded = Object.keys(container).length !== 0;

  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();

  const DETAILS_PER_CONV_TYPE = {
    pending: {
      icon: <DashedClockIcon />,
      title: t("PENDING"),
      unread: unreadBadges.pending,
      convsCount: totalCounts.pending,
    },
    ongoing: {
      icon: <MessagesBubbleIcon />,
      title: t("ONGOING"),
      unread: unreadBadges.ongoing,
      convsCount: totalCounts.ongoing,
    },
    otherConvs: {
      icon: <TradeIconComponent />,
      title: t("OTHERCONVS"),
      unread: false,
      convsCount: totalCounts.otherConvs,
      accessDenied: !otherConversationsFeatAccess && containerLoaded,
    },
  };

  const { icon, title, unread, convsCount, accessDenied } =
    DETAILS_PER_CONV_TYPE[type] || {};

  const renderConvsCount = convsCount !== 0 && (
    <div title={convsCount} className={styles.count}>
      {convsCount}
    </div>
  );

  const isSelected = selectedType === type;

  const handleSelect = () => {
    if (accessDenied) return;

    onSelectConvType(type);
  };

  const renderBadge = accessDenied ? (
    <LockedFeature
      classNames={{ notif: styles.access_denied_notif_box }}
      showOnlyInfoBadge={true}
    />
  ) : (
    renderConvsCount
  );

  return (
    <div
      onClick={handleSelect}
      className={styles.select_type}
      data-selected={isSelected}
      data-access-denied={accessDenied}
    >
      <span data-has-new-msg={unread} className={styles.type_icon}>
        {icon}
      </span>

      <div className={styles.badge_and_text}>
        <span className={styles.select_type__text}>{title}</span>
        {renderBadge}
      </div>
    </div>
  );
}

export default ConvSelectHead;
